import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class FileUtil {

    constructor(
        private translateService: TranslateService,
    ) { 
        this.translateService.onDefaultLangChange.subscribe(lang => {
        });
    }

    fileTypes: string[] = ['.pdf', '.jpg','.jpeg'];
    isCSVFile(file): boolean {
        return file.name.endsWith('.csv');
    }

    isJSONFile(file): boolean {
        return file.name.endsWith('.json');
    }

    isValidJSON(file): boolean {
        const fileReader = new FileReader();
        fileReader.readAsText(file, "UTF-8");
        try {
            JSON.parse(fileReader.result as string);
        } catch (e) {
            return false;
        }
        return true;
    }

    isValidEdmFileType(file): boolean {
        let validType = false;
        for (const fileType of this.fileTypes) {
                validType = file.name.toLowerCase().endsWith(fileType);
                if (validType) {
                    // return true;
                    break;
                }
        }
        // return file.name.endsWith('.csv') || file.name.endsWith('.docx') || file.name.endsWith('.doc') || file.name.endsWith('.pdf');
        return validType;
    }

    checkUploadFileSizeAndType(file, fileSize, fileTypes): string {
        let errorMessage = '';
        if (!this.isValidFileType(file, fileTypes)) {
            errorMessage = 'Please import only PDF and JPG files.';
        }
        const fileSizeExceeded = file != null && ((file.size > fileSize) || file.size <= 0);
        if (fileSizeExceeded) {
            const allowedLimitInMb = (+fileSize) / (1024 * 1024);
            errorMessage = this.translateService.instant('COMMON.CommonMessage_Filesizecannotbelessthan0mborgreatedthan', {Default: 'File size cannot be less than 0 MB or greater than'}) + " " + this.formatBytes(fileSize, 2);
        }
        return errorMessage;
    }

    isValidFileType(file, fileTypes): boolean {
        let validType = false;
        for (const fileType of fileTypes) {
                validType = file.name.toLowerCase().endsWith(fileType);
                if (validType) {
                    // return true;
                    break;
                }
        }
        // return file.name.endsWith('.csv') || file.name.endsWith('.docx') || file.name.endsWith('.doc') || file.name.endsWith('.pdf');
        return validType;
    }

    checkFileSize(file): boolean {
        return (file != null && ((file.size > environment.uploadFileSize) || file.size <= 0));
    }

    validateFile(file): string {
        let errorMessage = '';

        if (!this.isCSVFile(file)) {
            errorMessage = this.translateService.instant('COMMON.CommonMessage_Pleaseimportvalidcsvfile', {Default: 'Please import valid .csv file'});
        } else if (this.checkFileSize(file)) {
            errorMessage = this.translateService.instant('COMMON.CommonMessage_Pleaseuploadfile', {Default: 'Please upload file'}) + ' <=' + this.formatBytes(environment.uploadFileSize, 2);
        }

        return errorMessage;
    }

    IsJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    validateJSONFile(file): string {
        let errorMessage = '';

        if (!this.isJSONFile(file) ) {
            errorMessage = this.translateService.instant('COMMON.CommonMessage_Pleaseimportvalidjsonfile', {Default: 'Please import valid .json file'});            
        } else if (this.checkFileSize(file)) {
            errorMessage = this.translateService.instant('COMMON.CommonMessage_Pleaseuploadfile', {Default: 'Please upload file'}) + ' <=' + this.formatBytes(environment.uploadFileSize, 2);
        }

        return errorMessage;
    }

    readFileContent(file: File): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            if (!file) {
                resolve('');
            }
            const fileReader = new FileReader();
            fileReader.onload = (e) => {
                const text = fileReader.result.toString();
                resolve(text);
            };
            fileReader.readAsText(file);
        });
    }

    edmFileSizeExceeded(file): boolean {
        return (file != null && ((file.size > environment.edmUploadFileSize) || file.size <= 0));
    }

    alloweEdmFileTypes(file): string {
        let errorMessage = '';
        if (!this.isValidEdmFileType(file)) {
            errorMessage = this.translateService.instant('COMMON.CommonMessage_Pleaseimportvalidfile', {Default: 'Please import valid file'});
        }
        return errorMessage;
    }

    checkFileSizeAndType(file, fileSize): string {
        let errorMessage = '';
        if (!this.isValidEdmFileType(file)) {
            errorMessage = 'Please import only PDF and JPG files.';
        }
        const fileSizeExceeded = file != null && ((file.size > fileSize) || file.size <= 0);
        if (fileSizeExceeded) {
            const allowedLimitInMb = (+fileSize) / (1024 * 1024);
            errorMessage = this.translateService.instant('COMMON.CommonMessage_Filesizecannotbelessthan0mborgreatedthan', {Default: 'File size cannot be less than 0 MB or greater than'}) + " " + this.formatBytes(fileSize, 2);    
        }
        return errorMessage;
    }

    checkEdmFileSizeAndType(file): string {
        let errorMessage = '';
        if (!this.isValidEdmFileType(file)) {
            errorMessage = 'Please import only PDF and JPG files.';
        }
        if (this.edmFileSizeExceeded(file)) {
            const allowedLimitInMb = (+environment.edmUploadFileSize) / (1024 * 1024);
            errorMessage = this.translateService.instant('COMMON.CommonMessage_Filesizecannotbelessthan0mborgreatedthan', {Default: 'File size cannot be less than 0 MB or greater than'}) + " " + allowedLimitInMb + 'MB';       
        }
        return errorMessage;
    }

    formatBytes(bytes, decimals) {
        if (bytes === 0) {
            return '0 Bytes';
        }
        const k = 1024;
        const dm = decimals <= 0 ? 0 : decimals || 2;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }


    base64ToArrayBuffer(data) {
        var binaryString = window.atob(data);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
          var ascii = binaryString.charCodeAt(i);
          bytes[i] = ascii;
        }
        return bytes;
      };
}
